const ASSIGNLINK = {
  ASSIGN_LINK_HEADER: 'Assign link to operator',
  ASSIGN_LINK_OPERATOR_SELECT_LABEL: 'Choose operator',
  ASSIGN_LINK_OPERATOR_SELECT_TITLE: 'Choose operator',
  ASSIGN_LINK_INPUT_LABEL: 'Link',
  ASSIGN_LINK_GENERAL_PAGES_TITLE: 'All general pages',
  ASSIGN_LINK_GENERAL_PAGES_DESCRIPTION:
    'Pages that no operator has been assign to it yet',
  ASSIGN_LINK_FILL_ALL_FIELDS_ERROR: 'Please fill all fields',
  ASSIGN_LINK_SAVE_BTN_LABEL: 'Save',
  ASSIGN_LINK_TO_OPERATOR_DESC:
    'With this feature, there is no need for departmentalization and team creation. You can assign an operator to respond to your user conversations on a specific page so that they can manage and answer all conversations that have taken place on that page.',
  ERROR_MESSAGE: 'Filling in all fields is mandatory!',
  URL_ERROR_MESSAGE: 'Entering the link (URL) is essential!',
  OPERATOR_ERROR_MESSAGE: 'Selecting an operator is essential!',
};

export default ASSIGNLINK;
